<div class="container-fluid print-include">
  @if (!isLoading && receipt) {
    <div class="row justify-content-center">
      <div class="col-lg-6 col-md-8 pt-5 pb-3 title-panel">
        <h2 class="font-weight-extrabold align-self-center mb-0">
          {{ 'investment.paymentReceipt' | translate }}
        </h2>
        <div>
          {{
            (paymentGatewayName === 'Other'
              ? 'investment.paymentStatusMessageOther'
              : 'investment.paymentStatusMessage'
            )
              | translate
                : {
                    paymentGatewayName: paymentGatewayName,
                    paymentType: getPaymentTypeDisplay() | translate,
                  }
          }}
          <span class="tw-lowercase">{{ getTransactionStatus() | translate }}!</span>
        </div>
      </div>
    </div>
    <div class="row pb-5 invest-panel justify-content-center">
      <div class="col-lg-6 col-md-8 receipt-panel">
        <div class="mb-3 font-size-smaller">
          {{ receipt.createdAt | amDateFormat: 'D MMM YYYY, hh:mm A' }}
        </div>
        <div class="info mb-4 d-flex">
          <div class="w-75">{{ 'investment.transactionAmount' | translate }}</div>
          <div class="w-25 text-right">{{ receipt.amount | numberSuffix }}</div>
        </div>
        <div class="input-panel">
          <div class="input-label">{{ 'investment.investorName' | translate }}</div>
          <div class="input-field">
            {{ profile?.fullName || '-' }}
          </div>
        </div>
        <div class="input-panel">
          <div class="input-label">{{ 'investment.PaymentReferenceNo' | translate }}</div>
          <div class="input-field">
            {{ paymentGatewayName === 'Other' ? receipt.refNo : receipt.orderNo || '-' }}
          </div>
        </div>
        @if (paymentGatewayName === 'Other') {
          <div class="input-panel">
            <div class="input-label">{{ 'investment.campaignName' | translate }}</div>
            <div class="input-field">
              {{ campaignName || '-' }}
            </div>
          </div>
        }
        @if (paymentGatewayName === 'Other') {
          <div class="input-panel">
            <div class="input-label">{{ 'common.paymentMethod' | translate }}</div>
            <div class="input-field">
              @if (paymentType === PaymentType.MaybankFPX) {
                <span>MaybankFPX</span>
              }
              @if (paymentType === PaymentType.Cheque) {
                <span>Cheque</span>
              }
              @if (paymentType === PaymentType.Swift) {
                <span>Swift</span>
              }
              @if (paymentType === PaymentType.BankIn) {
                <span>Bank-In</span>
              }
              @if (paymentType === PaymentType.DuitNow) {
                <span>DuitNow</span>
              }
              @if (paymentType === PaymentType.Wallet) {
                <span>{{ 'paymentType.Wallet' | translate }}</span>
              }
              @if (!paymentType) {
                <span>-</span>
              }
            </div>
          </div>
        }
        @if (paymentGatewayName !== 'Other') {
          <div class="input-panel">
            @if (paymentGatewayName === 'FPX') {
              <div class="input-label">
                {{ 'investment.fpxTransactionNo' | translate }}
              </div>
            }
            @if (paymentGatewayName === 'DuitNow') {
              <div class="input-label">
                {{ 'investment.duitNowTransactionNo' | translate }}
              </div>
            }
            <div class="input-field">
              {{ receipt.transactionId || '-' }}
            </div>
          </div>
        }
        @if (paymentGatewayName !== 'Other') {
          <div class="input-panel">
            <div class="input-label">{{ 'investment.campaignName' | translate }}</div>
            <div class="input-field">
              {{ campaignName || '-' }}
            </div>
          </div>
        }
        @if (paymentGatewayName !== 'Other') {
          <div class="input-panel">
            <div class="input-label">{{ 'investment.InvestorBank' | translate }}</div>
            <div class="input-field">
              {{ receipt.bankName || '-' }}
            </div>
          </div>
        }
        @if (paymentGatewayName === 'Other') {
          <div class="input-panel">
            <div class="input-label">{{ 'investment.status' | translate }}</div>
            <div
              class="input-field"
              [class.text-green]="isPrimaryColour()"
              [class.text-primary]="!isPrimaryColour()"
            >
              {{ getTransactionStatus() | translate }}
            </div>
          </div>
        }
      </div>
    </div>
    <div class="row pb-5 justify-content-center print-exclude">
      <div class="col-lg-6 col-md-8 text-center">
        @if (receiptType == ReceiptType.Investment) {
          <a class="btn btn-primary font-size-larger" routerLink="/dashboard/pledges">
            {{ 'investment.viewInvestment' | translate }}
          </a>
        }
        @if (receiptType == ReceiptType.Wallet) {
          <a
            class="btn btn-primary font-size-larger"
            [routerLink]="receipt?.investmentId && receipt?.slug ? ['/equity',receipt.slug,'invest-now','payment',receipt.investmentId.toString()] : (receipt.tickerCode ? ['/pstx', receipt.tickerCode] : ['/pstx', 'account'])"
          >
            {{ 'Continue' | translate }}
          </a>
        }
        <div class="btn btn-primary-border font-size-larger" (click)="print()">
          {{ 'investment.printReceipt' | translate }}
        </div>
      </div>
    </div>
  }
  @if (!isLoading && !receipt) {
    <div class="row justify-content-center">
      <div class="col-lg-6 col-md-8 pt-5 pb-3 title-panel tw-text-center">
        {{
          (paymentGatewayName === 'Other'
            ? 'investment.pendingPaymentReceiptStatusOther'
            : 'investment.pendingPaymentReceiptStatus'
          ) | translate: { paymentGatewayName: paymentGatewayName }
        }}
      </div>
    </div>
  }
  @if (isLoading) {
    <agmo-loading></agmo-loading>
  }
</div>
